import { Component, Vue } from 'vue-facing-decorator';;
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { Compass, Check, Delete, CirclePlusFilled, TopRight, Memo, WarningFilled } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import ApiService from '@/services/ApiService';
import AuthService from '@/services/AuthService';

@Component(
{
    components:
    {
        Header,
        Breadcrumbs,
        Navigation,
		Compass,
		Check,
		Delete,
		CirclePlusFilled,
		TopRight,
        Memo,
        WarningFilled
    },
    enums:
    {
        NavigationIndex
    }
})

export default class TargetGroup extends Vue 
{
    private activeName : string = "1";  
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;
    private targetGroupModelList : TargetGroupModel[] = [];
    private loading : boolean = true;
    private processPercenatges : boolean = false;
    private formValid : boolean = false;
    private showDifficulty : boolean = false;
    private showCategories : boolean = false;
    private hasPermission: boolean[] = [] as boolean[];
    private toDelete : TargetGroupModel | undefined;
    private newTargetGroupModel : TargetGroupModel = {} as TargetGroupModel;
	private currentTargetGroup : TargetGroupModel | undefined;
    private targetGroupName : string = "";
    private difficulties : string[] = ['sehr einfach', 'einfach', 'mittel', 'schwer', 'sehr schwer'];
    private selectedDifficulties : number[] = [20, 20, 20, 20, 20];
    private selectedCounts : number[] = [1, 1, 1, 1, 1];
    private difficultySum : number = 0;
    private categorySum : number = 0;
    private optionCounts : OptionCountModel[] = [] as OptionCountModel[];
    private categoryList : CategoryModel[] = [] as CategoryModel[];
    private categoryTargetGroupList : CategoryTargetGroupModel[] | undefined = [];
    private totalOptionCount : number = 0;
    private totalQuestionCount : number = 0;
    private totalTargetCount : number = 0;
    private previewTargetCount : number = 28;
    private listSum : number[] = [];

    private rules =
    {
        name:
        [
            {
                required: true,
                message: 'Bitte geben Sie eine Bezeichnung ein.',
                trigger: 'blur'
            }
        ]
    };

    public async mounted()
    {
        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['TARG_SELECT'] = AuthService.hasPermission("TARG_SELECT");
        this.hasPermission['TARG_INSERT'] = AuthService.hasPermission("TARG_INSERT");
        this.hasPermission['TARG_UPDATE'] = AuthService.hasPermission("TARG_UPDATE");
        this.hasPermission['TARG_DELETE'] = AuthService.hasPermission("TARG_DELETE");
        
        if (this.hasPermission['TARG_SELECT'])
        {
            await this.loadList();
            await this.loadCategories();
            await this.loadCategorySums();
            this.getDifficultySum();

            this.newTargetGroupModel.questioncount = 1;
        }
        
        window.addEventListener('resize', this.onWindowResize);

        this.loading = false;
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private getDifficultySum()
    {
        let sum : number = 0;

        for (let val : number of this.selectedDifficulties)
        {
            sum += val;
        }
        
        this.difficultySum = sum;

        return sum;
    }

    private getCategorySum()
    {
        let sum : number = 0;

        for (let ct : CategoryTargetGroupModel of this.categoryTargetGroupList)
        {
            if (ct.percentage)
            {
                sum += ct.percentage;
            }
        }
        
        this.categorySum = sum;

        this.getTotalCount();

        return sum;
    }

    private getTotalCount()
    {
        this.totalTargetCount = 0;

        for (let ct : CategoryTargetGroupModel of this.categoryTargetGroupList)
        {
            let n : number = Math.round(this.previewTargetCount / 100 * ct.percentage);
            this.totalTargetCount += n;
        }

        if (this.categorySum == 100 && this.totalTargetCount < this.previewTargetCount)
        {
            this.categorySum = Math.round(100 / this.previewTargetCount * this.totalTargetCount);
        }

        if (this.totalTargetCount == this.previewTargetCount && this.categorySum != 100)
        {
            this.categorySum= 100;
        }
    }

    private async loadList()
    {
        this.loading = true;
        this.targetGroupModelList = await ApiService.getAllTargetGroups() as TargetGroupModel[];
        this.loading = false;
    }

    private async loadCategories()
    {
        this.loading = true;
        this.categoryList = await ApiService.getAllCategories() as CategoryModel[];
        this.loading = false;
    }

    private async loadCategoryPercentages()
    {
        this.loading = true;
        this.categoryTargetGroupList = await ApiService.getAllCategoriesForTargetGroup(this.currentTargetGroup.targetgroupid.toString()) as CategoryTargetGroupModel[];
        this.loading = false;
    }

    private async loadCategorySums()
    {
        for (let t : TargetGroupModel of this.targetGroupModelList)
        {
            let ct : CategoryTargetGroupModel | undefined = await ApiService.getCategoryPercentageSum(t.targetgroupid.toString());

            if (ct)
            {
                this.listSum[t.targetgroupid] = ct.sum;
            }
        }
    }

    private async loadCounts()
    {
        this.loading = true;
        this.optionCounts = await ApiService.getOptionCountsByTargetgroup(this.currentTargetGroup.targetgroupid.toString()) as OptionCountModel[];
        
        this.totalOptionCount = 0;
        this.totalQuestionCount = 0;

        if (this.optionCounts && this.optionCounts.length > 0)
        {
            this.totalQuestionCount = this.optionCounts[0].question_count;

            for (let item : OptionCountModel of this.optionCounts)
            {
                this.totalOptionCount += item.option_count;
            }
        }

        this.loading = false;
    }

    private getCategoryName(categoryid : number)
    {
        for (let cat : CategoryModel of this.categoryList)
        {
            if (cat.categoryid == categoryid)
            {
               return cat.name; 
            }
        }
    }

    private getPercentageValue(index : number)
    {
        this.selectedCounts[index] = Number(Math.floor(this.totalOptionCount / 100 * this.selectedDifficulties[index])).toFixed(0);
        return this.selectedCounts[index];
    }

    private async createTargetGroup()
    {
        // send new targetgroup model via request to API and await
        let targetgroup = await ApiService.createTargetGroup(this.newTargetGroupModel);

        // check if successful
        if (targetgroup)
        {
			ElMessage(
            {
                message: "Neue Zielgruppe erfolgreich erstellt.",
                type: 'success',
            });

            this.activeName = "1";
            this.newTargetGroupModel = {} as TargetGroupModel;
            this.newTargetGroupModel.questioncount = 1;
            this.formValid = false;
            await this.loadList();
        }
        else
        {
            // or show error message
			ElMessage(
            {
               	message: "Beim Erstellen der neuen Zielgruppe ist ein Fehler aufgetreten.",
               	type: 'error',
            });
        }
    }

    private async updateTargetGroup(targetgroup : TargetGroupModel)
    {
        let ok : any = await ApiService.updateTargetGroup(targetgroup);

        if (ok)
        {
			ElMessage(
            {
               	message: "Änderungen wurden übernommen.",
               	type: 'success',
            });
        }
        else
        {
            // or show error message
			ElMessage(
            {
               	message: "Änderungen konnten nicht gespeichert werden.",
               	type: 'error',
            });

        }
    }

    private async deleteTargetGroup(targetgroup : TargetGroupModel)
    {
        let ok = await ApiService.deleteTargetGroup(targetgroup);

        if (ok)
        {
			ElMessage(
            {
               	message: "Kategorie wurde gelöscht.",
               	type: 'success',
            });
            await this.loadList();
        }
        else
        {
            // or show error message
			ElMessage(
            {
               	message: "Kategorie konnte nicht gelöscht werden.",
               	type: 'error',
            });
        }
    }


    private validateForm() : boolean
    {
        if (!this.newTargetGroupModel.name || this.newTargetGroupModel.name.length <= 0) return false;

        return true;
    }

    private validatePercantage() : boolean
    {
        if (!this.optionCounts || this.optionCounts.length <= 0) return false;

        if (this.difficultySum != 100) return false;
        

        return true;
    }

    private validateCategoryPercantage() : boolean
    {
        if (this.categorySum != 100) return false;

        return true;
    }

    private onInput()
    {
        this.formValid = this.validateForm();
    }

    private onTargetGroupSaveClick(targetgroup : TargetGroupModel)
    {
        this.updateTargetGroup(targetgroup);
    }

    private onDeleteConfirm(action : string)
    {
        if (this.toDelete && action == 'confirm')
        {
            this.deleteTargetGroup(this.toDelete);
        }
    }

    private onTargetGroupDeleteClick(targetgroup : TargetGroupModel)
    {
        this.toDelete = targetgroup;

        ElMessageBox.confirm('Soll diese Zielgruppe wirklich gelöscht werden?', 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onDeleteConfirm,
            confirmButtonText: 'Löschen',
            cancelButtonText: 'Abbrechen'
        });
    }

    private onNewTargetGroupClick()
    {
        this.createTargetGroup();
    }

    private async onDifficultyClick(targetgroup : TargetGroupModel)
    {
        this.currentTargetGroup = targetgroup;
        this.targetGroupName = this.currentTargetGroup.name;

        this.selectedDifficulties[0] = this.currentTargetGroup.difficulty1;
        this.selectedDifficulties[1] = this.currentTargetGroup.difficulty2;
        this.selectedDifficulties[2] = this.currentTargetGroup.difficulty3;
        this.selectedDifficulties[3] = this.currentTargetGroup.difficulty4;
        this.selectedDifficulties[4] = this.currentTargetGroup.difficulty5;

        await this.loadCounts();

        this.showDifficulty = true;
    }

    private async onCategoryClick(targetgroup : TargetGroupModel)
    {
        this.currentTargetGroup = targetgroup;
        this.targetGroupName = this.currentTargetGroup.name;
        this.previewTargetCount = targetgroup.questioncount;

        await this.loadCategoryPercentages();
        await this.getCategorySum();

        this.showCategories = true;
    }

    private async onDifficultySave()
    {
        if (this.difficultySum == 100)
        {
            this.currentTargetGroup.difficulty1 = this.selectedDifficulties[0];
            this.currentTargetGroup.difficulty2 = this.selectedDifficulties[1];
            this.currentTargetGroup.difficulty3 = this.selectedDifficulties[2];
            this.currentTargetGroup.difficulty4 = this.selectedDifficulties[3];
            this.currentTargetGroup.difficulty5 = this.selectedDifficulties[4];

            this.currentTargetGroup = await ApiService.updateTargetGroup(this.currentTargetGroup);

            this.showDifficulty = false;
            
            ElNotification(
            {
                title: 'OK',
                message: 'Verteilung wurde gespeichert.',
                type: 'success',
                offset: 30
            });
        }
    }

    private async onCategoryDistributionSave()
    {
        this.processPercenatges = true;

        for (let ct : CategoryTargetGroupModel of this.categoryTargetGroupList)
        {
            await ApiService.updateCategoryTargetGroup(ct);
        }
        
        await this.loadCategorySums();

        this.processPercenatges = false;
        this.showCategories = false;
        this.categorySum = 0;
        
        ElNotification(
        {
            title: 'OK',
            message: 'Verteilung wurde gespeichert.',
            type: 'success',
            offset: 30
        });
    }

    private async onPreviewCountChange()
    {
        await this.getDifficultySum();
        await this.getCategorySum();
        await this.getTotalCount();
        await this.getPercentageValue();
    }
}
